exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-title[data-v-5b5f49ea]{font-size:1.4em;font-weight:700}.left-margin[data-v-5b5f49ea]{margin-left:20px}.title-font[data-v-5b5f49ea]{font-size:1.2em;font-weight:700}@media (max-width:1088px){.header-title-container[data-v-5b5f49ea]{display:flex;align-items:center;height:100%;text-align:center}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b5f49ea","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/header/NavigationItems/HeaderTitle.vue
// module id = FoNa
// module chunks = 18